// notificationUtils.js

// 1. Define the set of “shift detail” events
const SHIFT_DETAIL_EVENTS = new Set([
    'shift_approved',
    'shift_covered',
    'event_se_updated',               // edited shift
    'shift_comment',
    'shift_posted',
    'shift_detail',
    'vto_detail',
    'shift_start_reminder',
    'event_se_deleted',               // schedule element deleted
    'pending_reminder_single',        // shift reminder pending
    'uncovered_reminder_single',      // shift reminder uncovered
    'shift_pending',
    'shift_waiting_approval',
    'vto_waiting_approval',
    'shift_rejected',
    'pre_shift_reminder_coverer',
    'pre_shift_reminder_poster',
    'pickup_posted',                  // shift pickup posted
    'vto_rejected',
    'vto_pending',
    'vto_covered',
    'vto_approved',
    'vto_posted',
    'shift_applicant_free_post',
    'shift_public_comment_free_post',
    'shift_called_off',
    'no_cover_reminder',
]);

const SHIFT_APPLICANTS_EVENTS = new Set([
    'applicant_pick_closed',
    'applicant_create',
    'applicant_applied',
    'applicant_denied',
    'applicant_delete',
    'applicant_update',
]);

const SCHEDULE_VIEW_EVENTS = new Set([
    'calendar_schedule',
    'photo_schedule',
    'my_availability',
]);

/**
 * Returns true if the given notification event type
 * is one of the “shift detail”–related events.
 */
export function isTheEventRelatedToShiftDetail(eventType) {
    return SHIFT_DETAIL_EVENTS.has(eventType) || SHIFT_APPLICANTS_EVENTS.has(eventType);
}

export function isTheEventRelatedToScheduleView(eventType) {
    return SCHEDULE_VIEW_EVENTS.has(eventType);
}

